import { z } from 'zod'

import { SchoolTypeSchema } from '~/@entities/SchoolSystem'

/***************** 교육과정 구분 *****************/
export const OUT_OF_CURRICULUM_TYPE = ['CURRICULUM', 'EXTRA_CURRICULUM', 'PREVIOUS_GRADE'] as const

export const OutOfCurriculumTypeSchema = z.enum(OUT_OF_CURRICULUM_TYPE)
export type OutOfCurriculumType = z.infer<typeof OutOfCurriculumTypeSchema>

export const ConceptSummarySchema = z.object({
  conceptId: z.number(),
  totalUsed: z.number(),
  correctTimes: z.number(),
  wrongTimes: z.number(),
  answerRate: z.number(),
})
export type ConceptSummary = z.infer<typeof ConceptSummarySchema>

export const ConceptSchema = z.object({
  id: z.number(),
  curriculumId: z.number(),
  school: SchoolTypeSchema,
  // SchoolSystem 의 학년·학기가 아니다. 고등은 CMS 가 과목을 (grade, semester) 로 인코딩한다 —
  // grade 4 = 교육과정 외, semester 3 = 기하. GradeSchema·SemesterSchema 를 대면 고등 개념이 검증에서 깨진다.
  grade: z.number(),
  semester: z.number(),
  name: z.string(),
  url: z.string(),
  outOfCurriculumType: OutOfCurriculumTypeSchema,
  hidden: z.boolean(),
  conceptSummary: ConceptSummarySchema,
  // 서버 ConceptResponse 에는 없다. 다른 엔드포인트(Curriculum 트리)가 붙여 주는 값이라 optional.
  sequence: z.number().optional(),
})
export type Concept = z.infer<typeof ConceptSchema>

/***************** 주제·세부 주제 *****************/
const _SubTopicSchema = z.object({
  id: z.number(),
  name: z.string(),
  repProblemImageUrl: z.string().nullable(),
})
export type ConceptSubTopic = z.infer<typeof _SubTopicSchema>

export const ConceptTopicSchema = z.object({
  id: z.number(),
  name: z.string(),
  subTopics: z.array(_SubTopicSchema),
})
export type ConceptTopic = z.infer<typeof ConceptTopicSchema>
